import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import NotePageHeader from './NotePageHeader';
import { t } from '../i18n';
import apiClient from '../services/apiClient';
import NoteEditor from './NoteEditor';
import { noteText } from '../utils/notePresentation';
import './NoteDetail.css';

export default function MarketPublishFromNotePage() {
  const { noteId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const editorRef = useRef(null);
  const requestedListingId = location.state?.listingId;
  const vocabulary = data?.note?.studyKind === 'vocabulary' || location.state?.studyKind === 'vocabulary';
  const back = () => vocabulary ? navigate(`/vocabulary/notes/${encodeURIComponent(noteId)}`) : navigate('/map', { state: { noteId } });
  useEffect(() => {
    let cancelled = false;
    setData(null); setError('');
    apiClient.getNoteMetadata(noteId).then(async note => {
      const [cards, linked] = await Promise.all([
        apiClient.getAllFlashCards({ noteId, ...(note.studyKind === 'vocabulary' ? { studyKind: 'vocabulary' } : {}) }),
        requestedListingId ? apiClient.getLibraryMarketListing(requestedListingId).then(listing => ({ listing })) : apiClient.getMarketListingForNote(noteId),
      ]);
      if (note.sourcePresetId || note.sourceMarketListingId || (linked.listing && linked.listing.sourceNoteId !== noteId)) throw new Error(noteText('notFound'));
      if (!cancelled) setData({ note: { ...note, cards }, listing: linked.listing });
    }).catch(err => { if (!cancelled) setError(err.message || noteText('notFound')); });
    return () => { cancelled = true; };
  }, [noteId, requestedListingId]);

  return <div className="note-composer-page note-publication-page">
    <NotePageHeader title={noteText(data?.listing ? 'refresh' : 'publish')}
      description={noteText(data?.listing ? 'refreshHelp' : 'publicationHelp')} backLabel={t(vocabulary ? 'vocabulary.books' : 'interface.navigation.notes')}
      onBack={() => editorRef.current ? editorRef.current.requestCancel() : back()} />
    {error ? <p role="alert" className="note-detail-error">{error}</p> : !data ? <p role="status">{noteText('loading')}</p> : <>
      <NoteEditor ref={editorRef} key={noteId} initialNote={{ ...data.note, sourceType: 'market' }} destination="market" mode="publish" onCancel={back}
        onSave={async ({ noteTitle, isEnabled, deletedCardIds, ...payload }) => {
          const form = { ...payload, title: noteTitle };
          return data.listing
            ? await apiClient.refreshMarketListingFromNote(data.listing.id, form)
            : await apiClient.publishLibraryMarketListing({ ...form, sourceNoteId: noteId });
        }} onSaved={(listing) => navigate(`/market/${encodeURIComponent(listing.id)}`, { replace: true, ...(vocabulary ? { state: { libraryReturnTo: '/market?studyKind=vocabulary' } } : {}) })} />
    </>}
  </div>;
}
